/**
 *
 * RegularTrendsSignedIn
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Trends from './TrendsChart';
import useTrendsData from './hooks/useTrendsData';

const useStyles = makeStyles(theme => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      float: 'right',
      marginLeft: 24,
      maxWidth: 340,
    },
  },
  header: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
    },
  },
  callToAction: {
    lineHeight: 1.4,
    fontSize: '1.05em',
    fontFamily: 'PoppinsSemiBold',
    fontWeight: 600,
    marginTop: 8,
    marginBottom: 8,
  },
  callToActionButton: {
    display: 'flex',
    padding: '12px 40px',
    borderRadius: 4,
    color: 'white',
    backgroundColor: '#414141',
    justifyContent: 'center',
    width: '100%',
    ...theme.typography.caption,
    '&:hover': {
      backgroundColor: '#4E4D4D',
    },
  },
  disabledCta: {
    opacity: 0.7,
  },
}));

function RegularTrendsSignedIn({
  assessment,
  component,
  sortedIntervals,
  scale,
}) {
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const classes = useStyles();
  const data = useTrendsData({
    slug: _get(assessment, 'fields.slug'),
    displayIntervals: sortedIntervals,
    component,
  });

  if (_isEmpty(data)) return null;

  const parsedData = data.filter(item => item.score !== -1);
  if (_isEmpty(parsedData)) return null;

  return (
    <Grid item xs={12} md="auto" className={classes.wrapper}>
      <Typography variant="h6" color="textPrimary" className={classes.header}>
        {_get(assessmentResultsSiteCopy, 'pageCopy.trendsHeader')}
      </Typography>
      <Box component="div">
        <Trends
          scale={scale}
          sortedIntervals={sortedIntervals}
          values={parsedData}
          useScaleAsMax
          minMaxOnAxis
        />
      </Box>
    </Grid>
  );
}

RegularTrendsSignedIn.propTypes = {
  assessment: PropTypes.object,
  component: PropTypes.object,
  sortedIntervals: PropTypes.array,
  scale: PropTypes.number,
};

export default RegularTrendsSignedIn;
